module.exports = __webpack_public_path__ + "static/media/tex_me2.2ba88fd5.png";